exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iv-labeled-sections__panel+.iv-labeled-sections__panel[data-v-3978cdc6]{margin-top:24px}[data-v-3978cdc6] .nav-tabs{border-bottom:none}", ""]);

// exports
